import $ from 'jquery';

let scrolllengthArr = [];
const selectedval = '';
export const CalculateHieght = () => {
  scrolllengthArr = [];
  $('.inner-wrapper').each(function () {
    const offsetdt = $(this).offset();
    scrolllengthArr.push($(this).height() + offsetdt.top - $('#div').offset().top);
    // ($(this).height());
  });

  let totalHeight = 0;

  $('.custom-form-box')
    .children()
    .each(function () {
      totalHeight += $(this).outerHeight(true);
    });
  $('.custom-form-box').css('height', totalHeight + 300);
};

export const CustomForm = () => {
  $(document).ready(() => {
    // $(".formFirstField").focus();
    // $('#div :input:first').focus();
    let totalHeight = 0;

    $('.custom-form-box')
      .children()
      .each(function () {
        totalHeight += $(this).outerHeight(true);
      });
    $('.custom-form-box').css('height', totalHeight + 300);
    // alert($(".custom-form-box").height());

    const scolllength = 0;
    scrolllengthArr = [];

    // $(".inner-wrapper").each(function () {
    //     var offsetdt = $(this).offset();
    //     scrolllengthArr.push($(this).height() + offsetdt.top - $('.form-group').height() + 60 );
    // });

    $('.inner-wrapper').each(function () {
      const offsetdt = $(this).offset();
      scrolllengthArr.push($(this).height() + offsetdt.top - $('#div').offset().top);
      // ($(this).height());
    });

    $('.typeform-heading').click(function () {
      const lefttabindx = $(this).attr('tabindex');
      let scrollval = scrolllengthArr[$(this).attr('tabindex') - 1];
      if (scrollval == undefined || scrollval == 'undefined') {
        scrollval = -1;
      }
      $('#div').scroll();
      $('#div').animate(
        {
          scrollTop: scrollval,
        },
        'slow',
      );
      $('.inner-wrapper').removeClass('opaque');
      // $(".inner-wrapper").addClass("translucent");
      $(`.inner-wrapper[tabindex=${lefttabindx}]`).addClass('opaque');
      $(`.inner-wrapper[tabindex=${lefttabindx}]`).removeClass('translucent');
      $(`.inner-wrapper[tabindex=${lefttabindx}]`)
        .find(':input[type=text]')
        .focus();
      $(`.inner-wrapper[tabindex=${lefttabindx}]`)
        .find(':input[type=email]')
        .focus();
      $(`.inner-wrapper[tabindex=${lefttabindx}]`)
        .find('textarea')
        .focus();
      $('.typeform-heading[tabindex').removeClass('active-color');
      $('.typeform-heading[tabindex').removeClass('active-next-prev-color');
      $(`.typeform-heading[tabindex=${lefttabindx}]`).addClass('active-color');
      $(`.typeform-heading[tabindex=${lefttabindx}]`)
        .next('.typeform-heading')
        .addClass('active-next-prev-color');
      $(`.typeform-heading[tabindex=${lefttabindx}]`)
        .prev('.typeform-heading')
        .addClass('active-next-prev-color');
    });

    $('.upform-footer').on('keydown', function (e) {
      const keyCode = e.keyCode || e.which;
      if (keyCode == 38) {
        // Key Up
        const prevDiv = $(this)
          .prev('.inner-wrapper')
          .attr('tabindex');
        const scrollLength = scrolllengthArr.length;
        const lefttabindx = scrollLength;
        const scrollval = scrolllengthArr[scrollLength - 1];

        $('#div').scroll();
        $('#div').animate(
          {
            scrollTop: scrollval,
          },
          'slow',
        );

        $('.inner-wrapper').removeClass('opaque');
        // $(".inner-wrapper").addClass("translucent");

        $(this)
          .prev('.inner-wrapper')
          .find(':input')
          .focus();

        $(this)
          .prev('.inner-wrapper')
          .addClass('opaque');
        $(this)
          .prev('.inner-wrapper')
          .removeClass('translucent');

        $('.typeform-heading').removeClass('active-color');
        $('.typeform-heading').removeClass('active-next-prev-color');
        $(`.typeform-heading[tabindex=${lefttabindx}]`)
          .prev()
          .addClass('active-color');
        $(`.typeform-heading[tabindex=${lefttabindx}]`).addClass('active-next-prev-color');
        $(`.typeform-heading[tabindex=${lefttabindx}]`)
          .prev()
          .prev()
          .addClass('active-next-prev-color');
      }
    });

    $('.inner-wrapper').on('keydown', function (e) {
      const keyCode = e.keyCode || e.which;
      const lefttabindx = $(this).attr('tabindex');

      if (keyCode == 9) {
        // Tab Key
        const scrollval = scrolllengthArr[$(this).attr('tabindex')];
        const searchbox = $(this)
          .children('.form-group')
          .find('.selectsearch');

        {
          $('#div').scroll();
          $('#div').animate(
            {
              scrollTop: scrollval,
            },
            'slow',
          );
          // $(this).next('.inner-wrapper').focus();
          $(this)
            .next('.inner-wrapper')
            .addClass('opaque');
          $(this)
            .next('.inner-wrapper')
            .removeClass('translucent');
          // $(this).prev('.inner-wrapper').find(':input').focus();
          // $(this).addClass("translucent");
          $(this).removeClass('opaque');
          $('.typeform-heading').removeClass('active-color');
          $('.typeform-heading').removeClass('active-next-prev-color');
          $(`.typeform-heading[tabindex=${lefttabindx}]`)
            .next()
            .addClass('active-color');
          $(`.typeform-heading[tabindex=${lefttabindx}]`)
            .next()
            .next()
            .addClass('active-next-prev-color');
          $(`.typeform-heading[tabindex=${lefttabindx}]`).addClass('active-next-prev-color');
        }
        //  else
        //  {
        //      $(this).next('.upform-footer').find(':button').focus();
        //  }
      }
      /*
      else if (keyCode == 13) {
        // Enter Key
        var scrollval = scrolllengthArr[$(this).attr("tabindex")];
        var searchbox = $(this)
          .children(".form-group")
          .find(".selectsearch");
        var selectedflag = $(this)
          .children(".form-group")
          .find(".selected-flag");
        if (selectedflag.length > 0) {
          $(this)
            .children(".form-group")
            .find(".country-list")
            .attr("style", "display:none");
          //$(this).children('.form-group').find('input[type=tel]').focus();

          var next_wrapper = $(this).next(".inner-wrapper");
          setTimeout(function() {
            $("#div").scroll();
            $("#div").animate(
              {
                scrollTop: scrollval
              },
              "slow"
            );

            next_wrapper.find(":input").focus();
            $(".inner-wrapper[tabindex=" + lefttabindx + "]")
              .find("Table")
              .focus();
            next_wrapper.addClass("opaque");
            next_wrapper.removeClass("translucent");
            $(this).addClass("translucent");
            $(this).removeClass("opaque");
            $(".typeform-heading").removeClass("active-color");
            $(".typeform-heading").removeClass("active-next-prev-color");
            $(".typeform-heading[tabindex=" + lefttabindx + "]")
              .next()
              .addClass("active-color");
            $(".typeform-heading[tabindex=" + lefttabindx + "]")
              .next()
              .next()
              .addClass("active-next-prev-color");
            $(".typeform-heading[tabindex=" + lefttabindx + "]").addClass("active-next-prev-color");
            return false;
          }, 500);
        } else if (searchbox.length > 0) {
          //if(selectedflag.length==0)
          {
            var next_wrapper = $(this).next(".inner-wrapper");
            setTimeout(function() {
              $("#div").scroll();
              $("#div").animate(
                {
                  scrollTop: scrollval
                },
                "slow"
              );

              next_wrapper.find(":input").focus();
              $(".inner-wrapper[tabindex=" + lefttabindx + "]")
                .find("Table")
                .focus();
              next_wrapper.addClass("opaque");
              next_wrapper.removeClass("translucent");
              $(this).addClass("translucent");
              $(this).removeClass("opaque");
              $(".typeform-heading").removeClass("active-color");
              $(".typeform-heading").removeClass("active-next-prev-color");
              $(".typeform-heading[tabindex=" + lefttabindx + "]")
                .next()
                .addClass("active-color");
              $(".typeform-heading[tabindex=" + lefttabindx + "]")
                .next()
                .next()
                .addClass("active-next-prev-color");
              $(".typeform-heading[tabindex=" + lefttabindx + "]").addClass(
                "active-next-prev-color"
              );
              return false;
            }, 500);
          }
          var ddlTex = searchbox.find(".css-xp4uvy").text();
          if (ddlTex.indexOf("Select") > -1) {
            //do nothing
          } else {
          }
        } else {
          $("#div").scroll();
          $("#div").animate(
            {
              scrollTop: scrollval
            },
            "slow"
          );

          $(this)
            .next(".inner-wrapper")
            .find(":input")
            .focus();
          $(".inner-wrapper[tabindex=" + lefttabindx + "]")
            .find("Table")
            .focus();
          $(this)
            .next(".inner-wrapper")
            .addClass("opaque");
          $(this)
            .next(".inner-wrapper")
            .removeClass("translucent");
          $(this).addClass("translucent");
          $(this).removeClass("opaque");
          $(".typeform-heading").removeClass("active-color");
          $(".typeform-heading").removeClass("active-next-prev-color");
          $(".typeform-heading[tabindex=" + lefttabindx + "]")
            .next()
            .addClass("active-color");
          $(".typeform-heading[tabindex=" + lefttabindx + "]")
            .next()
            .next()
            .addClass("active-next-prev-color");
          $(".typeform-heading[tabindex=" + lefttabindx + "]").addClass("active-next-prev-color");
          return false;
        }
      } else if (keyCode == 38) {
        //Key Up

        var scrollval = scrolllengthArr[$(this).attr("tabindex") - 2];
        var searchbox = $(this)
          .children(".form-group")
          .find(".selectsearch");

        var selectedflag = $(this)
          .children(".form-group")
          .find(".selected-flag");
        var isdatepicker = $(this)
          .children(".form-group")
          .find(".e-datepicker");
        if (selectedflag.length > 0) {
          $(this)
            .children(".form-group")
            .find(".country-list")
            .attr("style", "display:none");
        }
        {
          if (scrollval == undefined) {
            scrollval = -1;
          }
          if (scrollval) {
            $("#div").scroll();
            $("#div").animate(
              {
                scrollTop: scrollval
              },
              "slow"
            );

            if ($(this).prev(".inner-wrapper").length > 0) {
              $(".inner-wrapper").removeClass("opaque");
              $(".inner-wrapper").addClass("translucent");

              $(this)
                .prev(".inner-wrapper")
                .find(":input")
                .focus();

              $(this)
                .prev(".inner-wrapper")
                .addClass("opaque");
              $(this)
                .prev(".inner-wrapper")
                .removeClass("translucent");

              $(".typeform-heading").removeClass("active-color");
              $(".typeform-heading").removeClass("active-next-prev-color");
              $(".typeform-heading[tabindex=" + lefttabindx + "]")
                .prev()
                .addClass("active-color");
              $(".typeform-heading[tabindex=" + lefttabindx + "]").addClass(
                "active-next-prev-color"
              );
              $(".typeform-heading[tabindex=" + lefttabindx + "]")
                .prev()
                .prev()
                .addClass("active-next-prev-color");
            }
          }
          return false;
        }
      } else if (keyCode == 40) {
        // Key Down

        var scrollval = scrolllengthArr[$(this).attr("tabindex")];

        var searchbox = $(this)
          .children(".form-group")
          .find(".selectsearch");

        var selectedflag = $(this)
          .children(".form-group")
          .find(".selected-flag");
        var isdatepicker = $(this)
          .children(".form-group")
          .find(".e-datepicker");

        // if(isdatepicker.length >0){

        //     $(this).children('.form-group').find('.e-datepicker').focus();
        //     $(this).children('.form-group').find('.selectsearch').attr("aria-expanded","true");
        // }
        // else
        if ((searchbox.length > 0 || selectedflag.length > 0) && isdatepicker.length == 0) {
          //do nothing
          if (e.which == 13) {
          }
        } else {
          if ($(this).attr("tabindex") < scrolllengthArr.length - 1) {
            $("#div").scroll();
            $("#div").animate(
              {
                scrollTop: scrollval
              },
              "slow"
            );

            $(this)
              .next(".inner-wrapper")
              .find(":input")
              .focus();
            $(this)
              .next(".inner-wrapper")
              .find("select")
              .focus();
            $(this)
              .next(".inner-wrapper")
              .find("ul")
              .focus();

            $(this)
              .next(".inner-wrapper")
              .addClass("opaque");
            $(this)
              .next(".inner-wrapper")
              .removeClass("translucent");
            $(this).addClass("translucent");
            $(this).removeClass("opaque");

            $(".typeform-heading").removeClass("active-color");
            $(".typeform-heading").removeClass("active-next-prev-color");
            $(".typeform-heading[tabindex=" + lefttabindx + "]")
              .next()
              .addClass("active-color");
            $(".typeform-heading[tabindex=" + lefttabindx + "]")
              .next()
              .next()
              .addClass("active-next-prev-color");
            $(".typeform-heading[tabindex=" + lefttabindx + "]").addClass("active-next-prev-color");
            return false;
          }
        }
      }
      */
    });

    $('.inner-wrapper').click(function (e) {
      const lefttabindx = $(this).attr('tabindex');

      if (e.target.className != 'form-btn' && e.target.className != '') {
        const scrollval = scrolllengthArr[$(this).attr('tabindex') - 1];

        $('#div').scroll();
        $('#div').animate(
          {
            scrollTop: scrollval,
          },
          'slow',
        );

        $('.inner-wrapper').removeClass('opaque');
        // $(".inner-wrapper").addClass("translucent");
        $(this).addClass('opaque');
        $(this).removeClass('translucent');

        $('.typeform-heading[tabindex').removeClass('active-color');
        $('.typeform-heading[tabindex').removeClass('active-next-prev-color');
        $(`.typeform-heading[tabindex=${lefttabindx}]`).addClass('active-color');
        $(`.typeform-heading[tabindex=${lefttabindx}]`)
          .next('.typeform-heading')
          .addClass('active-next-prev-color');
        $(`.typeform-heading[tabindex=${lefttabindx}]`)
          .prev('.typeform-heading')
          .addClass('active-next-prev-color');
      }
    });

    $('.inner-wrapper').on('click', '.form-btn', function (e) {
      // var lefttabindx = $(this).attr('tabindex');
      const lefttabindx = $(this)
        .parent()
        .parent()
        .attr('tabindex');
      let scrollval = scrolllengthArr[
        $(this)
          .parent()
          .parent()
          .attr('tabindex')
      ];
      if (scrollval == undefined || scrollval == 'undefined') {
        scrollval = -1;
      }
      $('#div').scroll();
      $('#div').animate(
        {
          scrollTop: scrollval,
        },
        'slow',
      );

      $('.inner-wrapper').removeClass('opaque');
      // $(".inner-wrapper").addClass("translucent");

      $(this)
        .parent()
        .parent()
        .next('.inner-wrapper')
        .find(':input')
        .focus();
      $(this)
        .parent()
        .parent()
        .next('.inner-wrapper')
        .addClass('opaque');
      $(this)
        .parent()
        .parent()
        .next('.inner-wrapper')
        .removeClass('translucent');
      // $(this).parent().parent().addClass('translucent');
      // $(this).parent().parent().removeClass('opaque');

      $('.typeform-heading[tabindex').removeClass('active-color');
      $('.typeform-heading[tabindex').removeClass('active-next-prev-color');
      $(`.typeform-heading[tabindex=${lefttabindx}]`)
        .next('.typeform-heading')
        .addClass('active-color');
      $(`.typeform-heading[tabindex=${lefttabindx}]`).addClass('active-next-prev-color');
      $(`.typeform-heading[tabindex=${lefttabindx}]`)
        .next()
        .next('.typeform-heading')
        .addClass('active-next-prev-color');
    });

    $('.form-group').on('click', '.input-area-section, .ql-container', function (e) {
      const lefttabindx = $(this).attr('tabindex');

      if (e.target.className != 'form-btn' && e.target.className != '') {
        const scrollval = scrolllengthArr[$(this).attr('tabindex') - 1];

        $('#div').scroll();
        $('#div').animate(
          {
            scrollTop: scrollval,
          },
          'slow',
        );

        $('.inner-wrapper').removeClass('opaque');
        // $(".inner-wrapper").addClass("translucent");
        $(this).addClass('opaque');
        $(this).removeClass('translucent');

        $('.typeform-heading[tabindex').removeClass('active-color');
        $('.typeform-heading[tabindex').removeClass('active-next-prev-color');
        $(`.typeform-heading[tabindex=${lefttabindx}]`).addClass('active-color');
        $(`.typeform-heading[tabindex=${lefttabindx}]`)
          .next('.typeform-heading')
          .addClass('active-next-prev-color');
        $(`.typeform-heading[tabindex=${lefttabindx}]`)
          .prev('.typeform-heading')
          .addClass('active-next-prev-color');
      }
    });
  });
};
